import type { PalletStatus, SensorStatus } from '../types/domain'

export const sensorStatusLabel: Record<SensorStatus, string> = {
  INACTIVE: 'Неактивен',
  INSTALLED: 'Установлен',
  READ_REQUIRED: 'Требует считывания',
  READING: 'Считывается',
  READ_LOCAL: 'Считан локально',
  SYNCED: 'Синхронизирован',
  MAINTENANCE: 'Обслуживание',
}

export const palletStatusLabel: Record<PalletStatus, string> = {
  DRAFT: 'Черновик',
  SENSORS_INSTALLED: 'Датчики установлены',
  IN_TRANSIT: 'В пути',
  READ_REQUIRED: 'Требует считывания',
  DATA_SYNCED: 'Данные синхронизированы',
  COMPLETED: 'Завершена',
}

export function dateTime(value?: string): string {
  if (!value) return '—'
  return new Intl.DateTimeFormat('ru-RU', { dateStyle: 'short', timeStyle: 'short' }).format(new Date(value))
}

export function number(value: number, maximumFractionDigits = 1): string {
  return new Intl.NumberFormat('ru-RU', { maximumFractionDigits }).format(value)
}

